import useDocumentTitle from '../hooks/useDocument';
import {Link} from 'react-router-dom';
import Header from '../components/header';
import Breadcrumb from '../components/breadcrumb';
import Features from '../components/features';
import CallToAction from '../components/calltoaction';
import Footer from '../components/footer';

function RewardView() {
  useDocumentTitle('Reward and recognition-Quality-Home-Healthcare');
  return (
    <div className="body-wrapper">
      <Header />
      <Breadcrumb image={'bg-image-28'} title={'Reward and recognition'} />

      <div className="ltn__page-details-area ltn__service-details-area mb-105">
        <div className="container">
          <div className="mb-3 color-border"></div>
          <div className="row">
            <div className="col-lg-8">
              <h2 className="text-left compassion">
                Quality Loyalty Rewards Program
              </h2>
              <div className="ltn__page-details-inner ltn__service-details-inner">
                <p className="values_p">
                  {' '}
                  <span className="ltn__first-letter">O</span>ur medical
                  professionals are at the forefront of the services we provide
                  to our clients. That's why it's so important to us to reward
                  them for their dedication to the success of quality health and
                  homecare services.
                </p>
                <h3> How to evaluate and reward your team</h3>
                <p className="values_p3">
                  We have developed industry-leading rewards and recognition
                  programs. We are very proud of it, and our caregivers say they
                  really appreciate the recognition and appreciation.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <aside className="sidebar-area ltn__right-sidebar">
                <h2 className="text-center compassion">Also see:</h2>
                <div className="widget-2 ltn__menu-widget ltn__menu-widget-2 text-uppercase">
                  <ul>
                    <li>
                      <Link to="/work-with">
                        Work with us
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li className="">
                      <Link to="/training">
                        Training
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/recruitment-process">
                        Recruitment Process
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>
      <div className="call-to-action-area call-to-action-5  bg-overlay-theme-90 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">1. Rates from £11.00 per hour</h2>
                <p className="white-color">
                  We want wage rates to reflect our value to caregivers and
                  their jobs. We, therefore, guarantee that our wage rate will
                  not fall below £11.00 per hour*. Nights, weekends, and
                  holidays will see an increase in hourly wages. All employees
                  receive paid vacation benefits in addition to their hourly
                  wages.
                </p>
                <span className="white-color">
                  * Shadow and training fees start at £10.50 per hour.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="compassion">2. 6 Cs Reward Scheme</h2>
                <p className="">6 Months Service Reward</p>
                <p>6 Cs Rewards Program</p>
                <p>
                  The 6Cs are the foundation for providing safe and quality care
                  services, and our company has adopted these 6Cs as the core
                  values ​​that underpin our business. These are:
                </p>
                <div>
                  <ul className="care_bullets-2">
                    <li>Care</li>
                    <li>Compassion</li>
                    <li>Communication</li>
                    <li>Courage</li>
                    <li>Committment</li>
                    <li>Competence</li>
                  </ul>
                </div>
                <p>
                  Our 6-Cs rewards program recognizes individuals within our
                  company who go above and beyond to demonstrate our core values
                  ​​in their work.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 compassion-bg pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">3. Service Award</h2>
                <p className="white-color">
                  6 months of continuous service reward
                </p>
                <p className="white-color">
                  Caregivers who have been with us for six months will receive a
                  Quality Health and Homecare Goodie Bag filled with special
                  gifts to reward their hard work. *
                </p>
                <p className="white-color">
                  Cash bonus for 12 months of service
                </p>
                <p className="white-color">
                  Our customers have ongoing medical needs. Continuity of care
                  is therefore very important to us. That's why after 12 months
                  of non-stop partnering with us, we reward nurses in cash for
                  their ongoing commitment to their clients. *{' '}
                </p>
                <p className="white-color">
                  Care staff who work with us for 6 months continually will
                  receive a Quality Health and Homecare goodie bag filled with
                  some special gifts to reward them for their hard work.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="compassion">4. Quarterly Prize Draw</h2>

                <p>
                  It is important to us that we recognize the compassion and
                  commitment that our care team demonstrates. Care staff who
                  attend all scheduled shifts throughout an entire quarter will
                  be entered into our quarterly prize draw. The winner receives
                  a spa day for two at their choice of location, giving them
                  some time to relax, unwind and feel rewarded for their hard
                  work and dedication. *
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5  bg-overlay-theme-90 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">5. The 6 Cs RecognitionScheme</h2>
                <p className="white-color">
                  We recognize our frontline and office-based staff for their
                  outstanding contributions to our core values. Nominations are
                  received from all staff, and winners are drawn at random on a
                  six-monthly basis. Every nomination is entered into the draw,
                  and the winners receive a spa day for two at their choice of
                  location.
                </p>
                <p className="white-color">
                  *Terms and Conditions: Minimum £11.00 per hour pay rate
                  applies to Grade B healthcare assistants and excludes shadow
                  shifts. The 6 and 12-month service rewards apply to care staff
                  who undertake continuous service with no break in regular work
                  for more than 4 weeks in a 12-month period and 2 weeks in a
                  6-month period. To be eligible, care staff must complete an
                  average of 24 working hours per week. The quarterly prize draw
                  applies to care staff who complete all booked shifts over a
                  12-week period with no cancellations for any reason, working a
                  minimum of 24 hours per week.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Features
        icon1="fas fa-chevron-right"
        icon2="fas fa-volume-up"
        text1=" Combining skills, expertise and knowledge to offer quality
                  care."
        text2="Read what our clients have to say about us.
        "
        link1="/team"
        link2="/testimonials"
        btn1="Meet our team"
        btn2="Read our testimonials"
      />
      <CallToAction />
      <Footer />
    </div>
  );
}

export default RewardView;
